import {
  DEFAULT_DATA_LABEL_SIZE_SMALL,
  compactFormat,
  dataLabelsCompact,
  dataLabelsDecimals,
  dataLabelsSizes,
  granularity,
  legendPosition,
  palette,
  showDataLabels,
  showItems,
} from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

export default <Config>{
  family: [FAMILY.OVERTIME],
  recommendedFamily: [FAMILY.OVERTIME],
  title: "Stacked Area Chart",
  defaultHeight: 6,
  controls: [granularity],
  settings: {
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },
    palette,
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "displayMetric",
    },
    decompositionMetric: {
      default: "month",
      type: "select",
      label: "Decomposition Metric 1",
      dictionary: "timeMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    decompositionMetricTop: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric 2",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    displayMetric: {
      default: "spend",
      type: "select",
      label: "Display Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },
  },
  planSettings: {
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },
    showDataLabels: { ...showDataLabels, gridPosition: [6, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, default: DEFAULT_DATA_LABEL_SIZE_SMALL, gridPosition: [6, 1] },
    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [7, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [7, 1] },
    palette,
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "displayMetric",
    },
    decompositionMetric: {
      default: "month",
      type: "select",
      label: "Decomposition Metric 1",
      dictionary: "timeMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    decompositionMetricTop: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric 2",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    displayMetric: {
      default: "channel_budget",
      type: "select",
      label: "Display Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },
  },
  planExploreSettings: {
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },
    showDataLabels: { ...showDataLabels, gridPosition: [6, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, default: DEFAULT_DATA_LABEL_SIZE_SMALL, gridPosition: [6, 1] },
    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [7, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [7, 1] },
    palette,
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "displayMetric",
    },
    decompositionMetric: {
      default: "month",
      type: "select",
      label: "Decomposition Metric 1",
      dictionary: "timeMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    decompositionMetricTop: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric 2",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    displayMetric: {
      default: "spend",
      type: "select",
      label: "Display Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },
  },
};
